/* [ECOMHARD] O controle de transparência pertence exclusivamente ao Slideshow. */
(function () {
  'use strict';
  if (window.__ecomhardHeaderOverlay) { window.__ecomhardHeaderOverlay.refresh(); return; }

  var body = document.body;
  var doc = document.documentElement;
  var selectedSection = null;
  var nav = null;
  var active = false;
  var scheduled = false;
  var hovering = false;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  // [ECOMHARD] V12: bloquear o fundo SEM position:fixed no body.
  // Fixar o body em -scrollY derrubava o header sticky ao abrir o menu fora do topo.
  var menuScrollLocked = false;
  var menuScrollY = window.pageYOffset || 0;
  var lastPageScrollY = menuScrollY;
  var menuTouchStartY = 0;
  var mobileMenuQuery = window.matchMedia('(max-width: 1199px)');
  var mobileScrolledPastTop = false;

  function updateMenuScrollLock() {
    // Só atuar no Header Parallax mobile, sem afetar carrinho e outros overlays.
    var shouldLock = mobileMenuQuery.matches &&
      !!document.querySelector('.wrapper_header_parallax [data-sticky-mb]') &&
      doc.classList.contains('translate-overlay');

    if (shouldLock && !menuScrollLocked) {
      menuScrollY = typeof window.pageYOffset === 'number' ? window.pageYOffset : (doc.scrollTop || 0);
      lastPageScrollY = menuScrollY;
      menuScrollLocked = true;
      doc.classList.add('ecomhard-mobile-menu-scroll-locked');
    } else if (!shouldLock && menuScrollLocked) {
      menuScrollLocked = false;
      doc.classList.remove('ecomhard-mobile-menu-scroll-locked');
      // Respeitar a posicao anterior sem deslocar o sticky no ato de abrir.
      if (Math.abs((window.pageYOffset || doc.scrollTop || 0) - menuScrollY) > 1) {
        window.scrollTo(0, menuScrollY);
      }
      lastPageScrollY = menuScrollY;
    }
  }

  // Em iOS o overflow:hidden isolado pode permitir scroll por gestos.
  // Bloqueamos o gesto fora do drawer e o rubber-band nas extremidades,
  // preservando o scroll normal dentro do menu e dos submenus.
  document.addEventListener('touchstart', function (event) {
    if (menuScrollLocked && event.touches && event.touches.length === 1) {
      menuTouchStartY = event.touches[0].clientY;
    }
  }, { passive: true });
  document.addEventListener('touchmove', function (event) {
    if (!menuScrollLocked || !event.cancelable || !event.touches || event.touches.length !== 1) return;
    var panel = document.querySelector('.wrapper_header_parallax .main-menu.jas-mb-style');
    if (!panel || !panel.contains(event.target)) { event.preventDefault(); return; }
    var scrolling = event.target;
    while (scrolling && scrolling !== panel) {
      if (scrolling.scrollHeight > scrolling.clientHeight + 1 &&
          /auto|scroll/.test(window.getComputedStyle(scrolling).overflowY)) break;
      scrolling = scrolling.parentElement;
    }
    if (!scrolling || !panel.contains(scrolling)) scrolling = panel;
    var dy = event.touches[0].clientY - menuTouchStartY;
    if (scrolling.scrollHeight <= scrolling.clientHeight + 1 ||
        (dy > 0 && scrolling.scrollTop <= 0) ||
        (dy < 0 && scrolling.scrollTop + scrolling.clientHeight >= scrolling.scrollHeight - 1)) {
      event.preventDefault();
    }
  }, { passive: false });
  document.addEventListener('wheel', function (event) {
    if (!menuScrollLocked || !event.cancelable) return;
    var panel = document.querySelector('.wrapper_header_parallax .main-menu.jas-mb-style');
    if (!panel || !panel.contains(event.target)) event.preventDefault();
  }, { passive: false });


  function onPointerEnter() { hovering = true; updateScroll(); }
  function onPointerLeave() { hovering = false; updateScroll(); }

  function clear() {
    if (nav) {
      nav.removeEventListener('pointerenter', onPointerEnter);
      nav.removeEventListener('pointerleave', onPointerLeave);
    }
    body.classList.remove('ecomhard-header-overlay-active', 'ecomhard-header-overlay-top');
    body.removeAttribute('data-ecomhard-overlay-mode');
    document.querySelectorAll('.ecomhard-slide-overlay-section').forEach(function (element) {
      element.classList.remove('ecomhard-slide-overlay-section');
    });
    doc.style.removeProperty('--ecomhard-overlay-height');
    nav = null;
    selectedSection = null;
    hovering = false;
    active = false;
    mobileScrolledPastTop = false;
  }

  function storiesVisible() {
    var stories = document.querySelector('.home-stories-slider-wrapper');
    return !!(stories && stories.getClientRects().length && stories.getBoundingClientRect().height > 2);
  }

  function isFirstVisibleSection(section) {
    var main = section.closest('main');
    if (!main) return false;
    var sections = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
    var current = sections.indexOf(section);
    if (current < 0) return false;
    for (var i = 0; i < current; i++) {
      if (sections[i].getBoundingClientRect().height > 8) return false;
    }
    return true;
  }

  function modalOpen() {
    return ['translate-overlay', 'cart-show', 'customer-show', 'search-open', 'options-show']
      .some(function (name) { return doc.classList.contains(name); });
  }

  function updateScroll() {
    if (!active || !nav) return;
    var scrollY = Math.max(0, window.pageYOffset || doc.scrollTop || 0);
    var transparent;
    if (mobileMenuQuery.matches) {
      // Evita alternância de cores/logo quando o plugin sticky muda a classe
      // enquanto o usuário passa pela borda do header (histerese).
      if (scrollY >= 60) mobileScrolledPastTop = true;
      else if (scrollY <= 12) mobileScrolledPastTop = false;
      transparent = !mobileScrolledPastTop && !modalOpen();
    } else {
      var sticky = !!nav.closest('.is-sticky');
      var navHeight = nav.getBoundingClientRect().height;
      var pastTop = scrollY > Math.max(20, navHeight * 0.55);
      transparent = !sticky && !pastTop && !modalOpen() && !(canHover.matches && hovering);
    }
    body.classList.toggle('ecomhard-header-overlay-top', transparent);
  }

  function refresh() {
    clear();
    var wrapper = document.querySelector('.wrapper_header_parallax');
    var header = wrapper && wrapper.querySelector('.header-parallax');
    if (!header) return;
    var desktop = window.matchMedia('(min-width: 1200px)').matches;
    if (!desktop && storiesVisible()) return;

    var slides = document.querySelectorAll('.ecomhard-slide-tailors');
    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      if (slide.getAttribute(desktop ? 'data-ecomhard-overlay-desktop' : 'data-ecomhard-overlay-mobile') !== 'true') continue;
      var section = slide.closest('.shopify-section');
      if (!section || !isFirstVisibleSection(section)) continue;
      var selectedNav = header.querySelector(desktop ? '[data-sticky-pc]' : '[data-sticky-mb]');
      if (!selectedNav) continue;
      var navHeight = selectedNav.getBoundingClientRect().height;
      if (navHeight < 20 || navHeight > 250) continue;
      // Não invadir seções intermediárias, inclusive barras promocionais externas.
      var gap = section.getBoundingClientRect().top - wrapper.getBoundingClientRect().bottom;
      if (gap < -12 || gap > 80) continue;

      selectedSection = section;
      nav = selectedNav;
      selectedSection.classList.add('ecomhard-slide-overlay-section');
      doc.style.setProperty('--ecomhard-overlay-height', Math.round(navHeight) + 'px');
      body.setAttribute('data-ecomhard-overlay-mode', desktop ? 'desktop' : 'mobile');
      body.classList.add('ecomhard-header-overlay-active');
      active = true;
      if (desktop && canHover.matches) {
        nav.addEventListener('pointerenter', onPointerEnter);
        nav.addEventListener('pointerleave', onPointerLeave);
        hovering = nav.matches(':hover');
      }
      updateScroll();
      return;
    }
  }

  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () { scheduled = false; refresh(); });
  }

  // [ECOMHARD] V15 — usar o acionador NATIVO, inclusive AJAX/sugestões do halo.js.
  // O clique do SVG do botão visual não pode borbulhar até click.hideSearch:
  // nesse handler o event.target seria <svg>/<path>, não a âncora original.
  // Disparamos o clique na própria âncora nativa (<a> como event.target),
  // que o halo.js reconhece como acionador válido em abrir E não fechar.
  document.addEventListener('click', function (event) {
    var target = event.target;
    var trigger = target && target.closest && target.closest('.ecomhard-mobile-search-trigger');
    if (!trigger || !mobileMenuQuery.matches || !body.classList.contains('ecomhard-header-overlay-active')) return;
    var wrapper = trigger.closest('.wrapper_header_parallax');
    if (!wrapper) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    var nativeTrigger = wrapper.querySelector('.header-mb-left .search-mb > a[data-search-mobile-toggle]');
    if (nativeTrigger) {
      nativeTrigger.click();
    } else {
      // Fallback apenas se o tema não renderizou a âncora nativa.
      doc.classList.add('search-open');
    }
    updateScroll();
    window.requestAnimationFrame(function () {
      var input = wrapper.querySelector('.header-mb-left .search-form input[type="search"]');
      if (doc.classList.contains('search-open') && input) {
        try { input.focus({ preventScroll: true }); } catch (error) { input.focus(); }
      }
    });
  }, true);

  window.__ecomhardHeaderOverlay = { refresh: scheduleRefresh };
  window.addEventListener('scroll', function () {
    if (!menuScrollLocked && !doc.classList.contains('translate-overlay')) {
      lastPageScrollY = window.pageYOffset || doc.scrollTop || 0;
    }
    updateScroll();
  }, { passive: true });
  window.addEventListener('resize', function () {
    updateMenuScrollLock();
    scheduleRefresh();
    window.setTimeout(scheduleRefresh, 220); // sticky é reconstruído após resize
  }, { passive: true });
  window.addEventListener('load', scheduleRefresh);
  // O menu Shopify alterna as classes em <html>, não em <body>.
  new MutationObserver(function () {
    updateMenuScrollLock();
    updateScroll();
  }).observe(doc, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('shopify:section:load', scheduleRefresh);
  document.addEventListener('shopify:section:unload', scheduleRefresh);
  document.addEventListener('shopify:section:reorder', scheduleRefresh);
  document.addEventListener('shopify:section:select', scheduleRefresh);
  document.addEventListener('shopify:section:deselect', scheduleRefresh);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleRefresh();
      updateMenuScrollLock();
    }, { once: true });
  } else {
    scheduleRefresh();
    updateMenuScrollLock();
  }
})();
